module.exports = __webpack_public_path__ + "static/media/NS_2do.93e9d0ef.jpg";